import styled from "styled-components";
import { BREAKPOINTS } from "../../variables/Breakpoints";
import { preventDrag } from "../../variables/Functions";
import { setFlex, setPosition } from "../../variables/Position";
import { COLOURS } from "../../variables/Colors";
import { cursor } from "../../variables/Cursors";

export const Container = styled.div`
  ${setPosition({ position: "relative" })};
  ${setFlex({ direction: "row" })};
  width: 100vw;
  height: auto;
  cursor: grab;
  ${cursor("grab")};
  &.grabbing {
    ${cursor("grabbing")};
  }
  ${preventDrag()};
  @media (max-width: ${BREAKPOINTS.sm}px) {
    min-height: auto;
  }
`;

export const Wrapper = styled.div`
  ${cursor("grab")};
  @media (max-width: ${BREAKPOINTS.sm}px) {
    display: none;
  }
`;

export const ImageWrapper = styled.div`
  width: 100%;
  height: auto;
  ${preventDrag()};
  ${props =>
    props.$quote &&
    `
    ${setPosition({ position: "absolute" })};
  `};
`;

export const DragImageWrapper = styled.div`
  width: 100vw;
  ${preventDrag()};
`;

export const DragImageContainer = styled.div`
  ${setPosition({ position: "relative" })};
  background-color: ${COLOURS.primary.black};
  height: 100%;
  ${preventDrag()};
`;

export const DragImage = styled.img`
  width: 100%;
  height: auto;
  ${preventDrag()};
`;
